import {createElement, nanoid, debounce} from '../utils/utils';

const MAX_EMPLOYERS = 20;

const workerBlock = document.querySelector('.js-employers-area');
const addBtn = document.querySelector('.js-btn-add');

const createTemplate = () => {
  const id = nanoid(5);
  return (
    `<div class="signing__form-block signing__form-block--bottom js-employer">
        <div class="custom-input">
          <label><span class="custom-input__label">ФИО</span>
            <input type="text" name="user-${id}-name" minlength="2" size="1">
          </label>
          <div class="custom-input__error" data-error data-required-text="Заполните поле" data-text="Некорректное имя">Некорректное имя</div>
        </div>
        <div class="custom-input" data-validate-type="phone">
          <label><span class="custom-input__label">Телефон</span>
            <input type="tel" name="user-${id}-phone" size="1">
          </label>
          <div class="custom-input__error" data-error data-required-text="Заполните поле" data-text="Некорректный телефон">Некорректный телефон</div>
        </div>
        <button class="js-btn-delete btn-reset tooltip signing__form-btn-delete" type="button" data-tooltip="Удалить"><span class="visually-hidden">Удалить</span>
          <svg width="15" height="16" aria-hidden="true">
            <use xlink:href="#icon-delete"></use>
          </svg>
        </button>
      </div>
    </div>`
  );
};

const checkEmployersCount = () => {
  const employers = workerBlock.querySelectorAll('.js-employer');

  if (addBtn && employers.length >= MAX_EMPLOYERS) {
    addBtn.disabled = true;
  } else if (addBtn && employers.length < MAX_EMPLOYERS) {
    addBtn.disabled = false;
  }
};

const addEmployer = () => {
  if (!workerBlock) {
    return;
  }

  const template = createTemplate();
  const element = createElement(template);
  workerBlock.append(element);
  checkEmployersCount();
};

const onWorkerBlockClick = (evt) => {
  const target = evt.target;

  if (!target) {
    return;
  }

  const deleteBtn = target.closest('.js-btn-delete');
  if (deleteBtn) {
    evt.preventDefault();
    const field = deleteBtn.closest('.js-employer');
    if (field) {
      field.remove();
      checkEmployersCount();
    }
  }
};

const onAddBtnClick = (evt) => {
  evt.preventDefault();
  addEmployer();
};

const initAddWorker = () => {
  if (!workerBlock && !addBtn) {
    return;
  }

  workerBlock.addEventListener('click', debounce(onWorkerBlockClick, 200));
  addBtn.addEventListener('click', debounce(onAddBtnClick, 200));
};

export {initAddWorker};
